
  import * as ipxRuntime$FBny_K1w6XPvhd0sOEKLGjqIx3RaiGOiFodH9z0kzrE from '/var/www/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "default": {
      "modifiers": {
        "format": "webp",
        "quality": 80
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "cdn.wildflamestudio.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpeg",
    "jpg",
    "gif",
    "png",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipx']: { provider: ipxRuntime$FBny_K1w6XPvhd0sOEKLGjqIx3RaiGOiFodH9z0kzrE, defaults: {"maxAge":604800,"modifiers":{"width":{"min":1,"max":3840},"height":{"min":1,"max":2160},"quality":{"min":10,"max":95}}} }
    }
  }
